import React from 'react';

type Props = {
  content: string;
};

export const AlertMessage: React.FC<Props> = ({ content }) => (
  <div className="ui warning message">
    <p>{content}</p>
  </div>
);
